import * as types from './types'

// action 存放的是方法
export default {
    getUser: ({commit}, user) => {
        commit(types.GETUSER, user);
    },
    //登录失效
    userAuthInvalid: (context) => {
      context.commit(types.EMPTYUSERINFO, { isLogin: false, user: {}})
    }
}



// WEBPACK FOOTER //
// ./src/store/actions.js